/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variant that replaces + and / with - and _ and omits padding, so the result is safe to use in URLs, query strings and filenames.`)
};

const es_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una variante que reemplaza + y / con - y _ y omite el relleno, por lo que el resultado es seguro de usar en URL, cadenas de consulta y nombres de archivo.`)
};

const de_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Variante, die + und / durch - und _ ersetzt und Auffüllzeichen auslässt, sodass das Ergebnis sicher in URLs, Abfrage-Strings und Dateinamen verwendet werden kann.`)
};

const nl_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een variant die + en / vervangt door - en _ en padding weglaat, dus het resultaat is veilig om te gebruiken in URL's, queryreeksen en bestandsnamen.`)
};

const fr_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une variante qui remplace + et / par - et _ et omet le remplissage, de sorte que le résultat est sûr à utiliser dans les URL, les chaînes de requête et les noms de fichiers.`)
};

const it_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una variante che sostituisce + e / con - e _ e omette il padding, quindi il risultato è sicuro da usare in URL, stringhe di query e nomi di file.`)
};

const pt_br2_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma variante que substitui + e / por - e _ e omite preenchimento, para que o resultado seja seguro para usar em URLs, cadeias de consulta e nomes de arquivo.`)
};

const pt_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma variante que substitui + e / por - e _ e omite preenchimento, para que o resultado seja seguro para usar em URLs, strings de consulta e nomes de ficheiro.`)
};

const ja_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+と/を-と_に置き換え、パディングを省略する変種で、結果はURL、クエリ文字列、ファイル名で安全に使用できます。`)
};

const zh_b64_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一种变体，将 + 和 / 替换为 - 和 _，并省略填充字符，因此结果可以安全地用于 URL、查询字符串和文件名中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_faq2_a", locale)
	if (locale === "en") return en_b64_faq2_a(inputs)
	if (locale === "es") return es_b64_faq2_a(inputs)
	if (locale === "de") return de_b64_faq2_a(inputs)
	if (locale === "nl") return nl_b64_faq2_a(inputs)
	if (locale === "fr") return fr_b64_faq2_a(inputs)
	if (locale === "it") return it_b64_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_b64_faq2_a(inputs)
	if (locale === "pt") return pt_b64_faq2_a(inputs)
	if (locale === "ja") return ja_b64_faq2_a(inputs)
	return zh_b64_faq2_a(inputs)
};